import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GYIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GY" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        stroke="#F7FCFF"
        d="M15.497 6 .5 11.293V.706L15.497 6Z"
      />
      <Path
        fill="#E11C1B"
        stroke="#272727"
        d="M7.186 6-.5 11.977V.021L7.186 6Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
